import jQuery from 'jquery'
import Swal from 'sweetalert2'
import '@fortawesome/fontawesome-free'
import 'bootstrap'
import Swiper, { Autoplay, Navigation, Pagination, EffectFade, Thumbs, Zoom } from 'swiper'
import 'aos/dist/aos.css'
import AOS from 'aos'

window.$ = window.jQuery = jQuery
window.Swal = Swal
window.Swiper = Swiper
window.Autoplay = Autoplay
window.Navigation = Navigation
window.Pagination = Pagination
window.EffectFade = EffectFade
window.Thumbs = Thumbs
window.Zoom = Zoom
window.Aos = AOS
